var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonthlyRevenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 26,
    viewBox: "0 0 39 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4545 15.1616V5.66159C27.4545 4.35534 26.4318 3.28659 25.1818 3.28659H9.27273C8.02273 3.28659 7 4.35534 7 5.66159V15.1616C7 16.4678 8.02273 17.5366 9.27273 17.5366H25.1818C26.4318 17.5366 27.4545 16.4678 27.4545 15.1616ZM25.1818 15.1616H9.27273V5.66159H25.1818V15.1616ZM17.2273 6.84909C15.3409 6.84909 13.8182 8.44034 13.8182 10.4116C13.8182 12.3828 15.3409 13.9741 17.2273 13.9741C19.1136 13.9741 20.6364 12.3828 20.6364 10.4116C20.6364 8.44034 19.1136 6.84909 17.2273 6.84909ZM32 6.84909V19.9116C32 21.2178 30.9773 22.2866 29.7273 22.2866H10.4091C10.4091 21.0991 10.4091 21.2178 10.4091 19.9116H29.7273V6.84909C30.9773 6.84909 30.8636 6.84909 32 6.84909Z",
    fill: "#FED600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthlyRevenue);
export default __webpack_public_path__ + "static/media/MonthlyRevenue.0bf1d39113cb4f3100b75803151f22d5.svg";
export { ForwardRef as ReactComponent };